import React from 'react';
import PropTypes from 'prop-types';
import CalendarItem from './../CalendarItem/CalendarItem';
import Flex from './../Flex/Flex';

const CalendarRow = (props) => {
  const items = props.row.map((item, idx) => {
    return <CalendarItem key={idx} {...item} />;
  });

  return <Flex data-testid='calendar-row-data-test-id'>{items}</Flex>;
};

CalendarRow.propTypes = {
  row: PropTypes.array,
};

export default CalendarRow;
